import {
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
} from "@material-ui/core";

import CustomDialog from "../../components/CustomDialog";
import useLocale from "../../../hooks/useLocale";
import GovGrButton from "../../../components/GovGrButton";
import GovGrErrorSummary from "../../../components/GovGrErrorSummary";

const ConfirmationModal = (props) => {
  const { open, message, submitAccept, submitReject } = props;
  const { t } = useLocale();

  return (
    <CustomDialog open={open} maxWidth="md">
      <DialogContent>
        <DialogContentText>
          <GovGrErrorSummary
            errorheading={t("Warning")}
            errorsummary={[{ error: t(message) }]}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid item>
            <GovGrButton
              onClick={submitAccept}
              variant="warning"
              buttonText={t("Yes, I want to cancel this application")}
            />
          </Grid>
          <Grid item>
            <GovGrButton
              onClick={submitReject}
              type="submit"
              variant="primary"
              buttonText={t("No, I want to continue applying")}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </CustomDialog>
  );
};

export default ConfirmationModal;
